import React, {useCallback} from 'react';
import {connect, useDispatch} from 'react-redux';
import {
  // Checkbox,
  Modal,
  PrimaryButton,
  SecondaryButton,
} from '../../components';
import * as Actions from '../../store/actions';
import {useMutation} from 'react-query';
import {
  retryVerification,
  revalidateVerification,
} from '../../requests/queries/verifications';
import {getCookieValue} from '../../helpers/getCookie';
import {useParams} from 'react-router-dom';
import {toast} from 'react-toastify';

function ReverificationModal({open, setOpen, setOpenSuccess, retryType}) {
  // const [invalidate, setInvalidate] = useState(false);
  const env = getCookieValue('env');
  const {slug} = useParams();
  const dispatch = useDispatch();

  const environment = env === 'Production' ? 'live' : env;
  const isRetry = retryType === 'retry';
  const confirmText = isRetry
    ? 'Confirm that you want to retry verification'
    : 'Clicking the confirm button, invalidates this verification.';

  const handleSuccessModal = () => {
    setOpen(false);
    isRetry
      ? setOpenSuccess(true)
      : toast.success('You have successfully initiated a reverification');
  };

  const {isLoading: revalidateLoading, mutate: revalidateMutation} =
    useMutation('re-verify', revalidateVerification, {
      onSuccess: () => {
        handleSuccessModal();
        dispatch(Actions.getSessionSummary(slug));
      },
    });

  const {isLoading: retryLoading, mutate: retryMutation} = useMutation(
    'retry',
    retryVerification,
    {
      onSuccess: () => {
        handleSuccessModal();
        dispatch(Actions.getSessionSummary(slug));
      },
    },
  );

  const handleValidation = useCallback(() => {
    try {
      const data = {
        verification_id: slug,
        environment,
        // ...(!isRetry ? {invalidate} : {}),
      };

      isRetry ? retryMutation(data) : revalidateMutation(data);
    } catch (e) {
      console.log(e);
    }
  }, [
    environment,
    // invalidate,
    isRetry,
    retryMutation,
    revalidateMutation,
    slug,
  ]);

  return (
    <Modal
      modalBg="bg-white80"
      modalTitle={`Are you sure you want to ${
        isRetry ? 'retry verification' : 're-verify user'
      }?`}
      show={open}
      onClose={setOpen}
      setOpen={setOpen}
      extraModalClasses="md:max-w-[500px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center"
      borderRadius="rounded-2xl"
    >
      <p className="text-[#8E90A9] text-sm text-left my-6 px-6">
        {confirmText}
      </p>

      {/*{!isRetry && (*/}
      {/*  <div className="my-3  w-full ">*/}
      {/*    <div className="bg-white80 rounded-md pl-3 ">*/}
      {/*      <Checkbox*/}
      {/*        label="Invalidate current verification"*/}
      {/*        className="py-[12px]"*/}
      {/*        labelStyle=" text-body leading-[18px] cursor-pointer"*/}
      {/*        align="items-start"*/}
      {/*        isChecked={invalidate}*/}
      {/*        onChange={e => setInvalidate(e.target.checked)}*/}
      {/*        noLeftPadding*/}
      {/*      />*/}
      {/*    </div>*/}

      {/*    <p className="text-xs text-brandBlue text-left my-4 cursor-pointer hover:underline ">*/}
      {/*      Learn how invalidating a verification works.{' '}*/}
      {/*    </p>*/}
      {/*  </div>*/}
      {/*)}*/}

      <div className="w-full mt-6 px-6 py-[14px] border-[0.5px] flex gap-4 border-transparent border-t-[#EFEFEF]">
        <SecondaryButton
          className="w-[50%] !h-10"
          buttonText="Cancel"
          onClick={() => setOpen(false)}
        />

        <PrimaryButton
          className="w-[50%] !h-10"
          onClick={() => {
            handleValidation();
          }}
          buttonText="Confirm"
          loading={retryLoading || revalidateLoading}
        />
      </div>
    </Modal>
  );
}

export default connect(state => state, Actions)(ReverificationModal);
